import { useDrop } from 'react-dnd'
import { useTreeState } from '../../../stores/Root'
import { StudioDraggableTypes } from '../StudioUtils'

const useTrackDrop = (stemIndex: number) => {
  const { studio } = useTreeState()
  // for reordering instrument tracks
  const [{ isOver: isTrackOver }, connectTrackDrop] = useDrop(
    () => ({
      accept: [StudioDraggableTypes.TRACK],
      drop: (item: any) => {
        if (item.type === StudioDraggableTypes.TRACK) {
          studio.song.changeStemIndex(
            item.stemIndex,
            item.stemIndex < stemIndex ? stemIndex - 1 : stemIndex
          )
          studio.updatePlayheadStartPosition()
        }
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver()
      })
    }),
    [stemIndex]
  )
  return { isTrackOver, connectTrackDrop }
}

export default useTrackDrop
